// extracted by mini-css-extract-plugin
export default {"tutorPhoto":"Details_tutorPhoto__YetpV","tutorActions":"Details_tutorActions__dG4zQ","tutorTrimmedText":"Details_tutorTrimmedText__DGD95"};